var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitData.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "p-8 sm:p-6" },
        [
          _c(
            "sw-input-group",
            {
              attrs: {
                label: _vm.$tc("settings.account_settings.email"),
                error: _vm.emailError,
              },
            },
            [
              _c("sw-input", {
                staticClass: "mt-2",
                attrs: {
                  invalid: _vm.$v.formData.email.$error,
                  placeholder: _vm.$t("settings.user_profile.email"),
                },
                on: {
                  input: function ($event) {
                    return _vm.$v.formData.email.$touch()
                  },
                },
                model: {
                  value: _vm.formData.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "email", $$v)
                  },
                  expression: "formData.email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              attrs: {
                label: _vm.$tc("settings.account_settings.password"),
                error: _vm.passwordError,
              },
            },
            [
              _c("sw-input", {
                staticClass: "mt-2",
                attrs: {
                  invalid: _vm.$v.formData.password.$error,
                  placeholder: _vm.$t("settings.user_profile.password"),
                  type: "password",
                },
                on: {
                  input: function ($event) {
                    return _vm.$v.formData.password.$touch()
                  },
                },
                model: {
                  value: _vm.formData.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "password", $$v)
                  },
                  expression: "formData.password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              staticClass: "mt-1 mb-2",
              attrs: {
                label: _vm.$tc("settings.account_settings.confirm_password"),
                error: _vm.confirmPasswordError,
              },
            },
            [
              _c("sw-input", {
                attrs: {
                  invalid: _vm.$v.formData.confirm_password.$error,
                  placeholder: _vm.$t("settings.user_profile.confirm_password"),
                  type: "password",
                },
                on: {
                  input: function ($event) {
                    return _vm.$v.formData.confirm_password.$touch()
                  },
                },
                model: {
                  value: _vm.formData.confirm_password,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "confirm_password", $$v)
                  },
                  expression: "formData.confirm_password",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "z-0 flex justify-end p-4 border-t border-gray-200 border-solid border-modal-bg",
        },
        [
          _c(
            "sw-button",
            {
              staticClass: "mr-3 text-sm",
              attrs: { type: "button", variant: "primary-outline" },
              on: { click: _vm.closeCompanyModal },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("general.cancel")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "sw-button",
            {
              attrs: {
                variant: "primary",
                type: "submit",
                loading: _vm.isLoading,
              },
            },
            [
              !_vm.isLoading
                ? _c("save-icon", { staticClass: "mr-2" })
                : _vm._e(),
              _vm._v(
                "\n      " +
                  _vm._s(
                    !_vm.isEdit
                      ? _vm.$t("general.save")
                      : _vm.$t("general.update")
                  ) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }